import React from "react"
import PropTypes from "prop-types"

import { StyledContainer } from './styles'

export const Container = ({ maxWidth, children, fluid, gutter = {}, addSpacers, ...props }) => {
  return (
    <StyledContainer {...{ maxWidth, fluid, gutter, addSpacers }} {...props}>
      {children}
    </StyledContainer>
  )
}

Container.propTypes = {
  fluid: PropTypes.bool,
  addSpacers: PropTypes.bool,
  gutter: PropTypes.object,
  maxWidth: PropTypes.string,
}
